import React from 'react';

import { formatCount, formatDateTime, formatRequestId, formatStatusLabel, formatTimeValue } from '../utils/format';

export default function PreviewTable({ downloading, onDownload, preview, report }) {
  return (
    <section className="panel">
      <div className="panel__header panel__header--split">
        <div>
          <span className="panel__eyebrow">Workbook preview</span>
          <h2>First generated rows</h2>
          <p>Review the first five rows before downloading the Excel workbook.</p>
        </div>

        {report ? (
          <button className="button button--secondary" disabled={downloading} onClick={() => onDownload(report)} type="button">
            {downloading ? 'Downloading...' : 'Download Excel'}
          </button>
        ) : null}
      </div>

      {!report ? (
        <div className="empty-state">Generate a report to unlock the Excel download and preview table.</div>
      ) : (
        <>
          <div className="summary-strip">
            <div>
              <span>Request</span>
              <strong>{formatRequestId(report.id)}</strong>
            </div>
            <div>
              <span>Workbook</span>
              <strong>{report.filename}</strong>
            </div>
            <div>
              <span>Rows</span>
              <strong>{formatCount(report.count)}</strong>
            </div>
            <div>
              <span>Created</span>
              <strong>{formatDateTime(report.createdAt)}</strong>
            </div>
          </div>

          <div className="table-shell">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Request ID</th>
                  <th>#</th>
                  <th>Receiver</th>
                  <th>Status</th>
                  <th>Sent Time</th>
                </tr>
              </thead>
              <tbody>
                {preview.length === 0 ? (
                  <tr>
                    <td className="table-empty" colSpan={6}>
                      No preview rows available for this report.
                    </td>
                  </tr>
                ) : (
                  preview.map((row) => (
                    <tr key={row.index}>
                      <td>{row.id}</td>
                      <td>{formatRequestId(row.requestId)}</td>
                      <td>{row.index}</td>
                      <td>{row.receiver}</td>
                      <td>
                        <span className={`status-pill status-pill--${row.status}`}>{formatStatusLabel(row.status)}</span>
                      </td>
                      <td>{formatTimeValue(row.sentTime)}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
    </section>
  );
}
